import { useEffect } from 'react';

/**
 * SEO dinámico para SPA React.
 * Gestiona:
 * - title
 * - description
 * - Open Graph
 * - Twitter
 * - canonical
 * - BreadcrumbList
 * - School Schema.org en la página principal
 */
function Seo({ title, description, breadcrumbs }) {
  useEffect(() => {
    if (title) {
      document.title = title;
    }

    const ensureMeta = (selector, attrName, attrValue) => {
      let meta = document.head.querySelector(selector);

      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute(attrName, attrValue);
        document.head.appendChild(meta);
      }

      return meta;
    };

    // DESCRIPTION
    if (description) {
      const metaDesc = ensureMeta(
        "meta[name='description']",
        'name',
        'description'
      );
      metaDesc.setAttribute('content', description);

      const ogDesc = ensureMeta(
        "meta[property='og:description']",
        'property',
        'og:description'
      );
      ogDesc.setAttribute('content', description);

      const twDesc = ensureMeta(
        "meta[name='twitter:description']",
        'name',
        'twitter:description'
      );
      twDesc.setAttribute('content', description);
    }

    // TITLE
    if (title) {
      const ogTitle = ensureMeta(
        "meta[property='og:title']",
        'property',
        'og:title'
      );
      ogTitle.setAttribute('content', title);

      const twTitle = ensureMeta(
        "meta[name='twitter:title']",
        'name',
        'twitter:title'
      );
      twTitle.setAttribute('content', title);
    }

    // CANONICAL
    const pathname = window.location.pathname || '/';
    const cleanPath =
      pathname === '/' ? '/' : pathname.replace(/\/+$/, '');

    const canonicalUrl =
      `https://drevopoznaniy.ru${cleanPath}`;

    let canonical =
      document.head.querySelector("link[rel='canonical']");

    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }

    canonical.setAttribute('href', canonicalUrl);

    // SCHOOL JSON-LD — только главная страница
    const SCHOOL_ID = 'seo-school-jsonld';
    let schoolScript = document.getElementById(SCHOOL_ID);

    if (cleanPath === '/') {
      const schoolData = {
        '@context': 'https://schema.org',
        '@type': 'School',
        '@id': 'https://drevopoznaniy.ru/#school',
        name: 'Древо Познаний',
        url: 'https://drevopoznaniy.ru/',
        telephone: '+7 (916) 122-21-12',
        email: 'Drevop@ya.ru',
        address: {
          '@type': 'PostalAddress',
          streetAddress: 'Красноармейская улица, 105',
          addressLocality: 'Раменское',
          addressRegion: 'Московская область',
          addressCountry: 'RU'
        }
      };

      if (!schoolScript) {
        schoolScript = document.createElement('script');
        schoolScript.id = SCHOOL_ID;
        schoolScript.type = 'application/ld+json';
        document.head.appendChild(schoolScript);
      }

      schoolScript.textContent = JSON.stringify(schoolData);
    } else if (schoolScript) {
      schoolScript.remove();
    }

    // BREADCRUMBS JSON-LD
    const BREADCRUMB_ID = 'seo-breadcrumb-jsonld';
    const existingBreadcrumb =
      document.getElementById(BREADCRUMB_ID);

    if (Array.isArray(breadcrumbs) && breadcrumbs.length > 0) {
      const data = {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: breadcrumbs.map((item, idx) => ({
          '@type': 'ListItem',
          position: idx + 1,
          name: item.name,
          item: item.url,
        })),
      };

      let script = existingBreadcrumb;

      if (!script) {
        script = document.createElement('script');
        script.id = BREADCRUMB_ID;
        script.type = 'application/ld+json';
        document.head.appendChild(script);
      }

      script.textContent = JSON.stringify(data);
    } else if (existingBreadcrumb) {
      existingBreadcrumb.remove();
    }

  }, [title, description, breadcrumbs]);

  return null;
}

export default Seo;
